import { forwardRef } from 'react';

const SvgrMock = forwardRef<HTMLSpanElement>((props, ref) => <span ref={ref} {...props} />);
SvgrMock.displayName = 'SvgrMock';

export const ReactComponent = SvgrMock;
// eslint-disable-next-line import/no-default-export
export default SvgrMock;
